import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, dateColumn, actionEditColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P410List({ dataTable, onChangeAction, searchLev1, setSearchLev1 }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    // const [globalFilter, setGlobalFilter] = useState(null);

    const actionTab = (data) => {
        console.log(data);
        setSearchLev1({
            ...searchLev1,
            versionNo: data ? data.versionNo : 0,
        });

        onChangeAction(2, data ? "แก้ไข" : "บันทึก");
    };

    const headerLabel = <span className="hidden-responsive">เพิ่มรายการใหม่</span>;
    const header = (
        <div className="table-header">
            <Button
                className="p-button p-button-success btn-hidden-responsive"
                label={headerLabel}
                icon="pi pi-plus"
                // onClick={() => setDialog({ dialog: true, action: 'บันทึก' })}
                onClick={() => actionTab()}
                autoFocus
            />
            {/* <span className="p-input-icon-left span-responsive">
                <i className="pi pi-search" />
                <InputText type="search" placeholder="คำค้น" className="btn-responsive" onInput={(e) => setGlobalFilter(e.target.value)} />
            </span> */}
        </div>
    );
    return (
        <div className="datatable-responsive-modify">
            {/* <div className="card"> */}
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    header={header}
                    // globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column sortable field="versionNo" header="แบบที่" body={(e) => normalColumn(e, "versionNo", "แบบที่")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="usagePeriod" header="ช่วงเวลาใช้ประเมิน" body={(e) => normalColumn(e, "usagePeriod", "ช่วงเวลาใช้ประเมิน")} headerStyle={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="remark" header="หมายเหตุ" body={(e) => normalColumn(e, "remark", "หมายเหตุ")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="updateUserName" header="ผู้บันทึก/แก้ไข" body={(e) => normalColumn(e, "updateUserName", "ผู้บันทึก/แก้ไข")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="updateDt" header="วันที่-เวลาที่แก้ไข" body={(e) => dateColumn(e, true, "updateDt", "วันที่-เวลาที่แก้ไข")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column header="แก้ไข" body={(e) => actionEditColumn(e, actionTab)} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            {/* </div> */}
        </div>
    );
}
